module.exports = __webpack_public_path__ + "assets/img/answer-on.69fe8bd8.svg";